import { useAtomValue } from "jotai";
import type { JSX } from "react";

import { useField } from "@frontend/hooks/form";
import { ReferenceField } from "@frontend/shared/reference-field";
import { useLingui } from "@lingui/react/macro";

import { clientForm, optionsAtom } from "../stores/editor";
import { Section } from "./Section";

const fields = clientForm.fields;

/**
 * Where the client is filed. The line of business is asked for by some kinds
 * of client only, which the kinds say for themselves.
 */
export function ClassificationSection(): JSX.Element {
  const { t } = useLingui();

  const options = useAtomValue(optionsAtom);
  const typeId = useField(fields.typeId);

  const needsField = options.types.find(
    (type) => type.id === typeId.value,
  )?.needsField;

  return (
    <Section icon="Tags" legend={t`Classification`}>
      <ReferenceField
        label={t`Status`}
        placeholder={t`Please choose an option`}
        items={options.statuses}
        field={fields.statusId}
      />

      <ReferenceField
        label={t`Kind`}
        placeholder={t`Please choose an option`}
        items={options.types}
        field={fields.typeId}
      />

      {true === needsField ? (
        <ReferenceField
          label={t`Line of business`}
          placeholder={t`Please choose an option`}
          items={options.fields}
          field={fields.fieldId}
        />
      ) : null}

      <ReferenceField
        label={t`Region`}
        placeholder={t`Please choose an option`}
        items={options.regions}
        field={fields.regionId}
      />
    </Section>
  );
}
